function updateCart(data) {
    console.log('updateCart-data', data);
    $('.cart-data[data-input="total_products"]').html(data.total_products);
    
    $('.cart-data[data-input="total"]').html(data.total);
    if(!data.remaining) {
        $('.floating-summary .remaining').addClass('hidden');
    } else {
        $('.floating-summary .remaining').removeClass('hidden');
    }
    $('.cart-data[data-input="remaining"]').html(data.remaining);

    // update the package selector
    if(data.package) {
        $('.select-package-trigger').removeClass('active');
        $('.select-package-trigger[data-package="'+data.package.package+'"]').addClass('active');
    }

    if(data.installments) {
        $('.installments').removeClass('hidden');
        $('.installments [name="installments"]').prop('disabled', false);
        $('.installments label').html(data.installments_label);
    } else {
        $('.installments').addClass('hidden');
        $('.installments [name="installments"]').prop('disabled', true);
        $('.installments [name="installments"]').prop('checked', false);
        $('.installments label').html(data.installments_label);
    }
}



$('body').on('click', '.cart-product-preview .switcher .add', function () {
    var $this = $(this);
    var switcher = $this.parents('.switcher');
    switcher.addClass('processing');

    $.ajax({
        type: 'POST',
        url: $this.attr('href'),
        data: {
            _token: $('meta[name="csrf-token"]').attr('content'),
            '_method': 'PUT',
            'qty': 1
        },
        dataType: 'json',
        success: function (data) {
            switcher.removeClass('processing');

            if (!data.success) {
                showNotice('Error', data.message, 'Close');
                return false;
            }

            if (data.order_product) {
                $('.selected', switcher).html(data.order_product.qty);
            }

            if (data.cart) {
                updateCart(data.cart);
            }

            return false;
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });

    // var amount = parseInt(switcher.find('.selected').html());
    // amount++;
    // switcher.find('.selected').html(amount);

    return false;
});


$('body').on('click', '.cart-product-preview .switcher .minus', function () {
    var $this = $(this);
    var switcher = $this.parents('.switcher');
    var amount = parseInt(switcher.find('.selected').html());
    
    if (amount >= 1) {
        amount--;
        switcher.addClass('processing');
        
        $.ajax({
            type: 'POST',
            url: $this.attr('href'),
            data: {
                _token: $('meta[name="csrf-token"]').attr('content'),
                '_method': 'PUT',
                'qty': 1
            },
            dataType: 'json',
            success: function (data) {
                switcher.removeClass('processing');
                
                if (!data.success) {
                    showNotice('Error', data.message, 'Close');
                    return false;
                }

                if (data.order_product) {
                    $('.selected', switcher).html(data.order_product.qty);
                }

                if(data.order_product.qty == 0) {
                    $this.parents('.cart-product-preview').remove();
                }

                if (data.cart) {
                    updateCart(data.cart);
                }
                return false;
            },
            error: function (request) {
                console.log(request.responseText);
            }
        });
    }
    // switcher.find('.selected').html(amount);

    return false;
});

$('body').on('click', '.delete-product', function () {
    var $this = $(this);
    $.ajax({
        type: 'POST',
        url: $this.attr('href'),
        data: {
            _token: $('meta[name="csrf-token"]').attr('content'),
            '_method': 'DELETE'
        },
        dataType: 'json',
        success: function (data) {
            if (!data.success) {
                showNotice('Error', data.message, 'Close');
                return false;
            }
            
            $this.parents('.cart-product-preview').remove();

            if (data.cart) {
                updateCart(data.cart);
            }
            return false;
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });

    return false;
});



// coupons
$('body').on('submit', '.cart .order-coupons .add-coupon form', function () {
    var $this = $(this);

    $('.cart .add-coupon .error').html('');
    $.ajax({
        type: 'POST',
        url: $this.attr('action'),
        data: {
            '_token': $('meta[name="csrf-token"]').attr('content'),
            'coupon_code': $('.cart .add-coupon [name="coupon_code"]').val()
        },
        dataType: 'json',
        success: function (data) {
            console.log(data);
            unloading();

            if (!data.success) {
                $('.cart .add-coupon .error').html(data.message);
                return false;
            }

            if (data.coupon) {
                $('.cart .order-coupons .applied-coupons ul').append(`<li class="order-coupon" data-order_coupon="${data.coupon.order_coupon}">
                    <p>${data.coupon.message}</p>
                    <a href="/cart/coupon/${data.coupon.order_coupon}" class="remove-coupon">Remove Coupon</a>
                </li>`);
            }

            if (data.cart) {
                updateCart(data.cart);
            }
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });

    return false;
});

$('body').on('click', '.cart .order-coupons .remove-coupon', function() {
    var $this = $(this);
    $.ajax({
        type: 'POST',
        url: $this.attr('href'),
        data: {
            '_token': $('meta[name="csrf-token"]').attr('content'),
            '_method': 'DELETE'
        },
        dataType: 'json',
        success: function (data) {
            console.log(data);
            unloading();

            if (!data.success) {
                showNotice('Error', data.message, 'close');
                return false;
            }

            $this.parents('.order-coupon').remove();

            if (data.cart) {
                updateCart(data.cart);
            }
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });
    
    return false;
});


// checkout
$('body').on('change', '.cart input#copy-billing', function() {
    var $this = $(this);
    if($this.prop('checked')) {
        $('.cart .billing input').each(function() {
            var input = $(this);
            var name = input.attr('name').replace('billing', 'shipping');
            console.log(name);
            $('.cart .shipping input[name="'+name+'"]').val(input.val());
        });
        return false;
    }
    
    $('.cart .shipping input').val('');
    
    return false;
});

$('body').on('click', '.cart .checkout .checkout-with-paypal', function () {
    var $this = $('.cart .checkout form');

    var error = false;
    var emailError = false;
    $('.required.paypal', $this).each(function () {
        var $this = $(this);
        if ($this.val() === '') {
            error = true;
        } else {
            if ($this.attr('name') === 'email') {
                if (!validateEmail($this.val())) {
                    emailError = true;
                }
            }
        }
    });

    if (error) {
        showNotice('Error', 'Please fill out all required fields', 'close');
        return false;
    }

    if (emailError) {
        showNotice('Error', 'Please enter a valid email address', 'close');
        return false;
    }

    loading();
    var payload = {};

    payload['_token'] = $('meta[name="csrf-token"]').attr('content');
    // payload.billing_first_name = $('input[name="billing_first_name"]', $this).val();
    // payload.billing_last_name = $('input[name="billing_last_name"]', $this).val();
    // payload.billing_street = $('input[name="billing_street"]', $this).val();
    // payload.billing_city = $('input[name="billing_city"]', $this).val();
    // payload.billing_state = $('input[name="billing_state"]', $this).val();
    // payload.billing_zip = $('input[name="billing_zip"]', $this).val();
    // payload.billing_email = $('input[name="billing_email"]', $this).val();
    // payload.billing_phone = $('input[name="billing_phone"]', $this).val();

    // payload.shipping_first_name = $('input[name="shipping_first_name"]', $this).val();
    // payload.shipping_last_name = $('input[name="shipping_last_name"]', $this).val();
    // payload.shipping_street = $('input[name="shipping_street"]', $this).val();
    // payload.shipping_city = $('input[name="shipping_city"]', $this).val();
    // payload.shipping_state = $('input[name="shipping_state"]', $this).val();
    // payload.shipping_zip = $('input[name="shipping_zip"]', $this).val();
    // payload.shipping_email = $('input[name="shipping_email"]', $this).val();
    // payload.shipping_phone = $('input[name="shipping_phone"]', $this).val();


    payload.billing_first_name = $('input[name="first_name"]', $this).val();
    payload.billing_last_name = $('input[name="last_name"]', $this).val();
    payload.billing_street = $('input[name="street"]', $this).val();
    payload.billing_city = $('input[name="city"]', $this).val();
    payload.billing_state = $('input[name="state"]', $this).val();
    payload.billing_zip = $('input[name="zip"]', $this).val();
    payload.billing_email = $('input[name="email"]', $this).val();
    payload.billing_phone = $('input[name="phone"]', $this).val();

    payload.shipping_first_name = $('input[name="first_name"]', $this).val();
    payload.shipping_last_name = $('input[name="last_name"]', $this).val();
    payload.shipping_street = $('input[name="street"]', $this).val();
    payload.shipping_city = $('input[name="city"]', $this).val();
    payload.shipping_state = $('input[name="state"]', $this).val();
    payload.shipping_zip = $('input[name="zip"]', $this).val();
    payload.shipping_email = $('input[name="email"]', $this).val();
    payload.shipping_phone = $('input[name="phone"]', $this).val();
    if ($('[name="installments"]').prop('checked')) {
        payload.installments = true;
    }
    payload.method = 'paypal';

    $.ajax({
        type: 'POST',
        url: $this.attr('action'),
        data: payload,
        dataType: 'json',
        success: function (data) {
            console.log(data);

            if (!data.success) {
                showNotice('Error', data.message, 'close');
                return false;
            }

            if(data.location) {
                window.location.href = data.location;
                return false;
            }

            closeModal();
            showNotice('Success', data.message, 'close');
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });

    return false;
});

$('body').on('submit', '.cart .checkout form', function () {
    var $this = $(this);

    var error = false;
    var emailError = false;
    $('.required.card', $this).each(function () {
        var $this = $(this);
        if ($this.val() === '') {
            error = true;
        } else {
            if ($this.attr('name') === 'email') {
                if (!validateEmail($this.val())) {
                    emailError = true;
                }
            }
        }
    });

    if (error) {
        showNotice('Error', 'Please fill out all required fields', 'close');
        return false;
    }

    if (emailError) {
        showNotice('Error', 'Please enter a valid email address', 'close');
        return false;
    }

    loading();
    var payload = {};

    payload['_token'] = $('meta[name="csrf-token"]').attr('content');
    // payload.billing_first_name = $('input[name="billing_first_name"]', $this).val();
    // payload.billing_last_name = $('input[name="billing_last_name"]', $this).val();
    // payload.billing_street = $('input[name="billing_street"]', $this).val();
    // payload.billing_city = $('input[name="billing_city"]', $this).val();
    // payload.billing_state = $('input[name="billing_state"]', $this).val();
    // payload.billing_zip = $('input[name="billing_zip"]', $this).val();
    // payload.billing_email = $('input[name="billing_email"]', $this).val();
    // payload.billing_phone = $('input[name="billing_phone"]', $this).val();

    // payload.shipping_first_name = $('input[name="shipping_first_name"]', $this).val();
    // payload.shipping_last_name = $('input[name="shipping_last_name"]', $this).val();
    // payload.shipping_street = $('input[name="shipping_street"]', $this).val();
    // payload.shipping_city = $('input[name="shipping_city"]', $this).val();
    // payload.shipping_state = $('input[name="shipping_state"]', $this).val();
    // payload.shipping_zip = $('input[name="shipping_zip"]', $this).val();
    // payload.shipping_email = $('input[name="shipping_email"]', $this).val();
    // payload.shipping_phone = $('input[name="shipping_phone"]', $this).val();

    payload.billing_first_name = $('input[name="first_name"]', $this).val();
    payload.billing_last_name = $('input[name="last_name"]', $this).val();
    payload.billing_street = $('input[name="street"]', $this).val();
    payload.billing_city = $('input[name="city"]', $this).val();
    payload.billing_state = $('input[name="state"]', $this).val();
    payload.billing_zip = $('input[name="zip"]', $this).val();
    payload.billing_email = $('input[name="email"]', $this).val();
    payload.billing_phone = $('input[name="phone"]', $this).val();

    payload.shipping_first_name = $('input[name="first_name"]', $this).val();
    payload.shipping_last_name = $('input[name="last_name"]', $this).val();
    payload.shipping_street = $('input[name="street"]', $this).val();
    payload.shipping_city = $('input[name="city"]', $this).val();
    payload.shipping_state = $('input[name="state"]', $this).val();
    payload.shipping_zip = $('input[name="zip"]', $this).val();
    payload.shipping_email = $('input[name="email"]', $this).val();
    payload.shipping_phone = $('input[name="phone"]', $this).val();
    if ($('[name="installments"]').prop('checked')) {
        payload.installments = true;
    }

    payload.method = 'card';

    // setup the token
    Stripe.setPublishableKey($('meta[name="stripe"]').attr('content'));
    Stripe.card.createToken(
        {
            name: $('input[name="billing_first_name"]', $this).val() + ' ' + $('input[name="billing_last_name"]', $this).val(),
            number: $('input[name="card_number"]', $this).val(),
            cvc: $('input[name="cvv"]', $this).val(),
            exp: $('input[name="expiry"]', $this).val(),
            address_line1: $('input[name="billing_street"]', $this).val(),
            address_state: $('input[name="billing_state"]', $this).val(),
            address_zip: $('input[name="billing_zip"]', $this).val()
        },
        function (status, response) {
            // console.log(response);
            if (response.error) {
                unloading();
                showNotice('Error', response.error.message, 'close');
                return false;
            }

            payload['_token'] = $('meta[name="csrf-token"]').attr('content');
            payload.stripe_token = response.id;

            
            payload.brand = response.card.brand;
            payload.last_four = response.card.last4;
            payload.month = response.card.exp_month;
            payload.year = response.card.exp_year;

            $.ajax({
                type: 'POST',
                url: $this.attr('action'),
                data: payload,
                dataType: 'json',
                success: function (data) {
                    console.log(data);
                    unloading();

                    if (!data.success) {
                        showNotice('Error', data.message, 'close');
                        return false;
                    }

                    if(data.location) {
                        window.location.href = data.location;
                        return false;
                    }

                    closeModal();
                    showNotice('Success', data.message, 'close');

                },
                error: function (request) {
                    console.log(request.responseText);
                }
            });

            return false;
        }
    );

    return false;
});